var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('ListConcedenteContatos',{attrs:{"concedente_id":_vm.concedente.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }